export function sendAnalyticsGoal(reachedGoal) {
    if (typeof ga !== 'undefined') {
        ga('send', 'event', '' + reachedGoal, document.URL);
    } else {
        console.warn('GA not configured');
    }

    if (typeof yaCounter21397717 !== 'undefined') {
        yaCounter21397717.reachGoal('' + reachedGoal);
    } else {
        console.warn('YA not configured');
    }
}

export function facebookPixelAddingToCart(modelId) {
    if (typeof fbq === 'undefined') {
        console.error('Facebook Pixel not connected');
        return;
    }

    fbq('track', 'AddToCart', {
        content_ids: [modelId],
        content_type: 'product',
    });
}

export function ecommerceCartItemChange({id, name, price, brand, category}, delta) {
    if (typeof dataLayer === 'undefined') {
        console.error('Google Tag Manager not connected');
        return;
    }

    dataLayer.push({
        ecommerce: {
            [(delta > 0) ? 'add' : 'remove']: {
                products: [{
                    id,
                    name,
                    price,
                    brand,
                    category,
                    quantity: Math.abs(delta),
                }],
            },
        },
    });
}

// TODO: Вынести работу с carrotquest в отдельный модуль
export function carrotQuestViewedProduct({name, url, price, image}) {
    if (typeof carrotquest === 'undefined') {
        console.error('Carrot quest not connected');
        return;
    }

    carrotquest.track('$product_viewed', {
        $name: name,
        $url: url,
        $amount: price,
        $img: image,
    });

    carrotquest.identify([{op: 'union', key: '$viewed_products', value: name }]);
}

export function carrotQuestAddingToCart({name, url, price, image}) {
    if (typeof carrotquest === 'undefined') {
        console.error('Carrot quest not connected');
        return;
    }

    carrotquest.track('$cart_added', {
        $name: name,
        $url: url,
        $amount: price,
        $img: image,
    });

    carrotquest.identify([
        {op: 'union', key: '$cart_items', value: name},
        {op: 'add', key: '$cart_amount', value: price},
    ]);
}

export function carrotQuestCartItemChange({name}, delta, totalPrice) {
    if (typeof carrotquest === 'undefined') {
        console.error('Carrot quest not connected');
        return;
    }

    carrotquest.identify([{op: (delta > 0) ? 'union' : 'delete', key: '$cart_items', value: name}]);
    carrotquest.identify([{op: 'update_or_create', key: '$cart_amount', value: totalPrice}]);
}
